// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/adviceresultitem.scss
// module id = 360
// module chunks = 2